/*
 * @Description: 权限管理
 * @Author: fxg
 * @Date: 2020-06-30 14:18:14
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-11-16 19:22:31
 */ 
import request from '@/utils/request'
export function saveOrUpdate(data) {
  return request({
    url: '/base/system/limits/apply/save_or_update',
    method: 'post',
    data,
  })
}
/**
 * @Description: 获取流程详情
 * @Param: 
 * @Author: wangwangwang
 * @param {*} data
 */
export function getFlowsDetails(params) {
  return request({
    url: '/base/system/limits/apply/get_detail',
    method: 'get',
    params,
  })
}
